export enum PortalType {
	MASTERS = "master",
	BACHELORS = "bachelor",
	PHD = "phd",
	SHORT_COURSES = "short",
	DISTANCE_LEARNING = "distance_learning",
	PREPARATION_COURSES = "preparation_courses"
}